var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9023 6.50346C22.6406 5.51804 21.8695 4.74196 20.8904 4.47858C19.1159 4 12 4 12 4C12 4 4.88415 4 3.10953 4.47858C2.13048 4.742 1.3594 5.51804 1.09769 6.50346C0.622192 8.28958 0.622192 12.0162 0.622192 12.0162C0.622192 12.0162 0.622192 15.7428 1.09769 17.5289C1.3594 18.5143 2.13048 19.258 3.10953 19.5214C4.88415 20 12 20 12 20C12 20 19.1158 20 20.8904 19.5214C21.8695 19.258 22.6406 18.5143 22.9023 17.5289C23.3778 15.7428 23.3778 12.0162 23.3778 12.0162C23.3778 12.0162 23.3778 8.28958 22.9023 6.50346V6.50346ZM9.67269 15.3996V8.63271L15.6202 12.0163L9.67269 15.3996V15.3996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3d04c32119e3ee7d62fb44ab74c25fa5.svg";
export { ForwardRef as ReactComponent };